// components/Footer.jsx
import React from 'react';
import '../assets/css/Footer.css';


const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>BPD Online Corp</h3>
          <p>Your trusted partner for virtual assistant solutions</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#why-us">Why Choose Us</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li><a href="#services">Virtual Assistants</a></li>
            <li><a href="#services">Specialized Staffing</a></li>
            <li><a href="#services">Performance Monitoring</a></li>
            <li><a href="#services">Backup & Replacement</a></li>
            <li><a href="#services">Payroll & Compliance</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Contact Info</h4>
          <p>📍 Bulacan, Philippines</p>
          <p>📧 info@bpdocorp.com</p>
          <p>🌐 www.bpdocorp.com</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 BPD Online Corp. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;